import store from '../store/store';
import { actions as changeClientReduxActions } from '../partials/selectClient/reducers';
import checkIfSimcardsShouldBeShown from './checkIfSimcardsShouldBeShown';
import checkIfIoTShouldBeShown from './checkIfIoTShouldBeShown';
import { doesArrayHasLength } from './isDefined';

const changeClient = async ({ client }) => {
  const hasCientSimcards = await checkIfSimcardsShouldBeShown(client.id);

  let hasCientIoTSubs = false;

  store.dispatch(
    changeClientReduxActions.setSelectedClient({
      ...client,
      hasCientSimcards,
      hasCientIoTSubs
    })
  );

  if (doesArrayHasLength(client?.metadata?.account_ids)) {
    const rules = store.getState().auth?.user?.rules;
    if (rules) {
      hasCientIoTSubs = await checkIfIoTShouldBeShown(client.id, rules);
    }
  }

  return store.dispatch(
    changeClientReduxActions.setSelectedClient({
      ...client,
      hasCientSimcards,
      hasCientIoTSubs
    })
  );
};

export default changeClient;
